import { getMagicTextColor, getTextStyle } from "cms/theme/helpers";
import Styled from "styled-components";

export interface ContainerProps {
  $isActive?: boolean;
}
export const Container = Styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 0 100%;
  box-sizing: border-box;
  gap: 1.5rem;
  padding: 1.25rem 1.25rem 0 1.25rem;
  border: 1px solid #E8E8E8;
  border-radius: 1rem;
  transition: opacity 0.5s ease-in-out;
  cursor: pointer;

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 2.5rem;
    padding: 2.25rem 2.25rem 0 2.25rem;
    flex: 0 0 29.5rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    flex: 0 0 25%;
    gap: 0;
    padding: 1rem;
    align-self: stretch;
    justify-content: flex-start;
    border: 1px solid transparent;
    ${(props: ContainerProps) =>
      props.$isActive &&
      `
      background-color: #F5F5F5;
      border: 1px solid #E8E8E8;
    `}
  }
`;

export const ContentContainer = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  align-self: flex-start;
  gap: 0.75rem;
`;

export const HeadlineContainer = Styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const IconContainer = Styled.div`
  width: 1.5rem;
  height: 1.5rem;

  img {
    width: 100%;
    height: 100%;
  }
`;

export interface HeadlineProps {
  $showMagicText: boolean;
}

export const Headline = Styled.span<HeadlineProps>`
  ${(props) => getTextStyle(props.theme, "L2")}
  ${(props) => props.$showMagicText && `${getMagicTextColor(props.theme)}`}
`;

export const Illustration = Styled.div`
  width: 100%;
  height: 101%;
  border-radius: 0.5rem 0.5rem 0 0;
  box-shadow: 0px 4px 24px -4px rgba(3, 3, 3, 0.12);

  .gatsby-image-wrapper {
    border-radius: 0.5rem 0.5rem 0 0;
  }
`;
